import { Fragment } from 'react/jsx-runtime';

import { Box, Divider, Typography } from '@mui/material';
import { emptyState } from '@frontend/assets';

import { CartItem } from '../CartItem';
import { useCart } from '../CartContext';
import { useTranslation } from 'react-i18next';

interface Props {
  p?: number;
  gap?: number;
}

export const CartContent = ({p = 3, gap = 3} : Props) => {
  const { t } = useTranslation();
  const { state } = useCart();
  const services = state?.items || [];
  return (
    
    <Box
      p={p}
      gap={gap}
      display="flex"
      flexDirection="column"
    >
      {services.map((service, index) => (
        <Fragment key={service.id}>
          {index !== 0 && <Divider />}
          <CartItem service={service} />  
        </Fragment>
      ))}
      {
        !services.length && (
          <>
            <Box textAlign="center">
              <img width="140px" src={emptyState} />
            </Box>
            <Box textAlign="center">
              <Typography variant="body2">{t('common.tableList.empty')}</Typography>
            </Box>
          </>
        )
      }
    </Box>

    
  );
};
